import { isPivotModeEnabled } from '../pivot/pivotMode'

export const isOperatorUser = (roles: string[]): boolean =>
  roles.some((role) => role === 'admin' || role === 'operator')

const API_REDIRECT_TO_MARKET: Record<string, string> = {
  '/operator': '/operator',
  '/operator/labeling': '/operator',
  '/supplier/catalog': '/catalog',
  '/buyer/catalog': '/catalog',
  '/supplier/overview': '/overview',
  '/buyer/overview': '/overview',
}

export const mapApiRedirectPath = (path: string | null | undefined): string => {
  if (!path) {
    return homePathForUser([])
  }
  const mapped = API_REDIRECT_TO_MARKET[path] ?? '/overview'
  if (!isPivotModeEnabled()) {
    return mapped
  }
  if (path.startsWith('/supplier')) {
    return '/settings'
  }
  if (mapped === '/overview' || mapped === '/catalog') {
    return '/my-prices'
  }
  return mapped
}

export const homePathForUser = (roles: string[]): string => {
  if (isOperatorUser(roles)) {
    return '/operator'
  }
  if (isPivotModeEnabled()) {
    const supplierOnly = roles.includes('supplier') && !roles.includes('buyer')
    return supplierOnly ? '/settings' : '/my-prices'
  }
  return '/overview'
}
